module.exports = __webpack_public_path__ + "static/media/laptop-castle.8804a53d.png";